<template>
  <div class="mobile-navigation-flyout-fi">
    <mobile-navigation-first-level-fi
      :home-data="homeData"
      :navigation-data="navigationData"
      :logo-header="logoHeader"
      :service-navigation="serviceNavigation"
    />
    <mobile-navigation-sub-level-fi @show-country-selection="$emit('show-country-selection')" />
  </div>
</template>

<script setup lang="ts">
import type { ImageFieldValue, LinkFieldValue } from '@/sitecoreFieldTypes';
import type { SitecoreNavigation } from '@/sitecoreState';

import MobileNavigationFirstLevelFi from './mobile-navigation-first-level-fi/MobileNavigationFirstLevelFi.vue';
import MobileNavigationSubLevelFi from './mobile-navigation-sub-level-fi/MobileNavigationSubLevelFi.vue';

defineOptions({
  name: 'MobileNavigationFlyoutFi',
});

defineProps<{
  serviceNavigation: SitecoreNavigation[];
  logoHeader: ImageFieldValue | undefined;
  homeData: LinkFieldValue | null;
  navigationData: SitecoreNavigation[];
}>();

defineEmits<{
  'show-country-selection': [value: void];
}>();
</script>

<style scoped src="./mobile-navigation-flyout-fi" />
